import { V1Table as Table } from '@uhg-abyss/web/ui/Table';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Link } from '@uhg-abyss/web/ui/Link';
import { ProcessingStatItem } from '../ProcessingStatsItem';

export const PCPRolloverCount = ({ procStatsList, onChildValueChange }) => {
  const handlePCPReport = (e) => {
    e.preventDefault();
    onChildValueChange('PROR');
  };

  return (
    <ProcessingStatItem title="PCP Rollover Count">
      <Layout.Group grow>
        <Table.Container title="">
          <Table.TableBody>
            <Table.Row>
              <Table.Cell>
                {' '}
                <Link onClick={handlePCPReport}>Total Rollover Eligible</Link>
              </Table.Cell>
              <Table.Cell>
                {procStatsList?.pcpRolloverCounts?.pcpRolloverTotal}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>Total Rollover successful</b>
              </Table.Cell>
              <Table.Cell>
                {procStatsList?.pcpRolloverCounts?.totalRolloverSuccessful}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>Total Rollover Failure, Successfully Randomized </b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.pcpRolloverCounts
                    ?.totalRolloverFailureSuccessfullyRandomized
                }
              </Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell>
                <b>Total Rollover and Randomization Failure</b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.pcpRolloverCounts
                    ?.totalRolloverAndRandomizationFailure
                }
              </Table.Cell>
            </Table.Row>
          </Table.TableBody>
        </Table.Container>
      </Layout.Group>
    </ProcessingStatItem>
  );
};
